export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SingleImage.vue?vue&type=template&id=458bc058&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SingleImage.vue?vue&type=template&id=458bc058&scoped=true&
// module id = 289
// module chunks = 0